import Navbar  from "../../../NavBar/NavBar.js";
import Footer from "../../../Home/Footer.js"
import Whatsapp from "../../../Home/Whatsapp.js";
import Spinner from "../../../Home/Spinner.js";
import SectionUs1 from "./page_us/Solution-US-1/SectionUs1.js";
import { useEffect } from "react";



const PlafondsMursTendus = () =>{
  useEffect(() => {
  const pageUrl = "https://unik-system.com/voile-dombrage-maroc";
  const imageUrl =
    "https://unik-system.com/static/media/US_SHADE.17a0cfc79cc2895c8f99.webp";

  // ========= HELPER =========
  const setMeta = (name, content, isProperty = false) => {
    const attr = isProperty ? "property" : "name";
    let tag = document.querySelector(`meta[${attr}="${name}"]`);
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute(attr, name);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
  };

  // ========= TITLE =========
  document.title =
    "Voile d’ombrage Maroc Sur Mesure | Terrasse, Jardin & Piscine – UNIK SYSTEM";

  // ========= DESCRIPTION =========
  setMeta(
    "description",
    "Installation de voile d’ombrage au Maroc 🇲🇦. Solution sur mesure pour terrasse, jardin et parking avec protection UV et design moderne."
  );

  // ========= KEYWORDS =========
  setMeta(
    "keywords",
    `
    voile d ombrage maroc,
    voile ombrage terrasse maroc,
    voile ombrage jardin maroc,
    toile ombrage maroc,
    ombrage piscine maroc,
    voile solaire maroc,
    shade sail morocco,
    UNIK SYSTEM maroc
    `
  );

  setMeta("robots", "index, follow, max-image-preview:large");

  // ========= CANONICAL =========
  let canonical = document.querySelector("link[rel='canonical']");
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.rel = "canonical";
    document.head.appendChild(canonical);
  }
  canonical.href = pageUrl;

  // ========= OPEN GRAPH =========
  setMeta("og:title", document.title, true);
  setMeta(
    "og:description",
    "Voile d’ombrage design et protection solaire extérieure au Maroc.",
    true
  );
  setMeta("og:image", imageUrl, true);
  setMeta("og:url", pageUrl, true);
  setMeta("og:type", "website", true);

  // ========= SCHEMA SANS PRIX =========
  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "LocalBusiness",
        name: "UNIK SYSTEM",
        url: "https://unik-system.com",
        image: imageUrl,
        address: {
          "@type": "PostalAddress",
          addressCountry: "MA"
        }
      },
      {
        "@type": "Service",
        name: "Voile d’ombrage Maroc",
        description:
          "Installation de voile d’ombrage sur mesure pour terrasse, jardin et parking.",
        provider: {
          "@type": "Organization",
          name: "UNIK SYSTEM"
        },
        areaServed: {
          "@type": "Country",
          name: "Morocco"
        },
        serviceType: "Protection solaire extérieure"
      },
      {
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Accueil",
            item: "https://unik-system.com"
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Voile d’ombrage",
            item: pageUrl
          }
        ]
      }
    ]
  };

  let script = document.querySelector("#schema");
  if (!script) {
    script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "schema";
    document.head.appendChild(script);
  }

  script.innerHTML = JSON.stringify(schema);

}, []);


  
    return(
        <div className="body">
            <Spinner/>
            <Navbar/>
            <Whatsapp/>
            <SectionUs1/>
            <Footer/>
        </div>    
    )
};

export default PlafondsMursTendus;